"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = void 0;
var imgix_core_js_1 = __importDefault(require("imgix-core-js"));
var BASE_S3 = 'https://superhi.s3.amazonaws.com';
var DOMAIN_S3 = 'superhi-assets.imgix.net';
var BASE_URL_S3 = "https://" + DOMAIN_S3;
var BASE_CONTENTFUL = 'https://images.ctfassets.net/p388ooye9zl3';
var DOMAIN_CONTENTFUL = 'superhi-contentful.imgix.net';
var BASE_URL_CONTENTFUL = "https://" + DOMAIN_CONTENTFUL;
var client = new imgix_core_js_1.default({
    domain: DOMAIN_S3,
    // secureURLToken: '<SECURE TOKEN>',
});
var cleanPath = function (path) {
    return path.replace(BASE_S3, '').replace('?', '').replace(BASE_CONTENTFUL, '');
};
var getFullUrl = function (path, type) {
    return type === 's3' ? path : "" + BASE_URL_CONTENTFUL + path.replace(BASE_URL_S3, '');
};
var buildUrl = function (path, options) {
    return getFullUrl(client.buildURL(cleanPath(path), __assign({ fit: 'max', auto: 'format' }, options)), path.startsWith(BASE_S3) ? 's3' : 'contentful');
};
exports.buildUrl = buildUrl;
